export function calculateSummaryMetrics(projects) {
  const withoutAi = projects.reduce((acc, project) => acc + project.withoutAiHours, 0);
  const withAi = projects.reduce((acc, project) => acc + project.withAiHours, 0);
  const gain = withoutAi > 0 ? Math.round(((withoutAi - withAi) / withoutAi) * 100) : 0;

  return { withoutAi, withAi, gain };
}

export function calculateProjectRatio(project) {
  if (!project?.withoutAiHours || project.withoutAiHours <= 0) {
    return 10;
  }

  return Math.max(10, (project.withAiHours / project.withoutAiHours) * 100);
}
